/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import React from "react"
import { Route, Switch } from "react-router-dom"
import NoMatch from "./app_pages/404Page"
import IndexPage from "./app_pages/IndexPage"
// styled-components is not a component, so it should not be lazy-loaded
import styled from "styled-components"
import NasdaqLoader from "./components/common/NasdaqLoader"
import NewAffiliates from "./modules/NewAffiliates/NewAffiliates"
import RegistrationPage from "./app_pages/RegistrationPage"
import SymbolDirectory from "./modules/Downloads/SymbolDirectory"
import DocDownload from "./modules/Downloads/DocDownload"
import SymbolGenerator from "./components/common/SymbolGenerator"

const PortfolioManager = React.lazy(() => import("./modules/Portfolio/PortfolioManager"))
const OrganizationApprovalPage = React.lazy(() => import("./app_pages/OrganizationApprovalPage"))
const OrganizationManagerPage = React.lazy(() => import("./app_pages/OrganizationManagerPage"))
const IssuerManagerPage = React.lazy(() => import("./app_pages/IssuerManagerPage"))
const ProtectedRoute = React.lazy(() => import("./_protectedRoute"))
const DashBoard = React.lazy(() => import("./modules/Dashboard"))
const DocumentManagement = React.lazy(() => import("./modules/Document/DocumentManagement"))
const ProductManager = React.lazy(() => import("./modules/Product/ProductManager"))
const NewsCategoryManager = React.lazy(() => import("./modules/NewsCategoryManager/NewsCategoryManager"))
const ExcludedSymbolsManager = React.lazy(() => import("./modules/ExcludedSymbolsManager/ExcludedSymbolsManager"))
const PropertyManager = React.lazy(() => import("./modules/PropertyManager/PropertyManager"))
const ProductManagement = React.lazy(() => import("./modules/Product/ProductManagement"))
const InstrumentManagement = React.lazy(() => import("./modules/Instrument/InstrumentManagement"))
const BatchApplicationUpload = React.lazy(() => import("./modules/BatchApplicationUpload/BatchApplicationUpload"))
const AwaitingCompletion = React.lazy(() => import("./modules/Instrument/AwaitingCompletion"))
const PendingApproval = React.lazy(() => import("./modules/Instrument/PendingApproval"))
const LiveInstruments = React.lazy(() => import("./modules/Instrument/LiveInstruments"))
const DeletedInstruments = React.lazy(() => import("./modules/Instrument/DeletedInstruments"))
const InstrumentHistory = React.lazy(() => import("./modules/InstrumentHistory/InstrumentHistory"))
const InstrumentExpenseManager = React.lazy(() => import("./modules/InstrumentExpense/InstrumentExpenseManager"))
const ProductFix = React.lazy(() => import("./modules/ProductFix/ProductFix"))
const DeleteInstrumentComponent = React.lazy(() => import("./modules/Instrument/DeleteInstrumentComponent"))
const AllContacts = React.lazy(() => import("./modules/Contacts/AllContacts"))
const InstrumentSummary = React.lazy(() => import("./modules/Instrument/InstrumentSummary"))
const AllUsers = React.lazy(() => import("./modules/Users/AllUsers"))
const DailyListApproval = React.lazy(() => import("./modules/DailyList/DailyListApproval"))
const DailyListDownload = React.lazy(() => import("./modules/Downloads/DailyListDownload"))
const InstrumentDocumentDownload = React.lazy(() => import("./modules/Downloads/InstrumentDocumentDownload"))
const BulkChangeManager = React.lazy(() => import("./modules/BulkChanges/BulkChangeManager"))
const ProductDownload = React.lazy(() => import("./modules/Downloads/ProductDownload"))
const BillingContactsReport = React.lazy(() => import("./modules/Contacts/BillingContactsReport"))
const MarketCloseCalendar = React.lazy(() => import("./modules/MarketCloseCalendar/MarketCloseCalendar"))
const ServiceAccessKey = React.lazy(() => import("./modules/Downloads/ServiceAccessKey"))
const AuditDashboard = React.lazy(() => import("./modules/Audit/AuditDashboard"))
const ReconciliationReport = React.lazy(() => import("./modules/Workday/ReconciliationReport"))
const BatchExpenseUpload = React.lazy(() => import("./modules/InstrumentExpense/BatchExpenseUpload"))
const ContentManagementSystem = React.lazy(() => import("./modules/ContentManagementSystem/ContentManagementSystem"))
// const DocDownload = React.lazy(() => import("./modules/Downloads/DocDownload"))

const StyledMain = styled.main`
  flex-grow: 1;
`

/*
Important when adding a new route:
If the route is private or public, make sure to add it in keyToPathMap and keyToIconMap and routes API.
ID in the private routes should match with the keys mentioned in keyToPathMap and keyToIconMap and the API response
*/
const Routes = () => {
  return (
    <StyledMain>
      <Switch>
        <Route exact key="/" path="/" component={IndexPage} />
        <Route key="new_affiliates" path="/new_affiliates/:id" component={NewAffiliates} />
        <Route key="register" path="/register" component={RegistrationPage} />
        <Route exact key="doc_download" path="/doc_download/:documentId" component={DocDownload} />
        <Route key="symbol_generator" path="/symbol_generator" component={SymbolGenerator} />
        <React.Suspense fallback={<NasdaqLoader />}>
          <ProtectedRoute exact id="audit_logs" path="/audit_logs" component={AuditDashboard} />
          <ProtectedRoute id="users" path="/users" component={AllUsers} />
          <ProtectedRoute id="daily_list_approval" path="/daily_list_approval" component={DailyListApproval} />
          <ProtectedRoute id="bulk_manager" path="/bulk_manager" component={BulkChangeManager} />
          <ProtectedRoute id="contacts" path="/contacts" component={AllContacts} />
          <ProtectedRoute id="organization_approval" path="/organization_approval" component={OrganizationApprovalPage} />
          <ProtectedRoute id="organization_manager" path="/organization_manager" component={OrganizationManagerPage} />
          <ProtectedRoute id="issuer_manager" path="/issuer_manager" component={IssuerManagerPage} />
          <Route key="user_dashboard" path="/user_dashboard" component={DashBoard} />
          <ProtectedRoute id="product_form" path="/product_form" component={ProductManagement} />
          <ProtectedRoute exact id="document_manager" path="/document_manager" component={DocumentManagement} />
          <ProtectedRoute exact id="product_management" path="/product_management" component={ProductManager} />
          <ProtectedRoute exact id="property_manager" path="/property_manager/:propertyType" component={PropertyManager} />
          <ProtectedRoute exact id="news_category_manager" path="/news_category_manager" component={NewsCategoryManager} />
          <ProtectedRoute exact id="excluded_symbols_manager" path="/excluded_symbols_manager" component={ExcludedSymbolsManager} />
          <ProtectedRoute exact id="instrument_manager" path="/instrument_manager" component={InstrumentManagement} />
          <ProtectedRoute exact id="batch_application_upload" path="/batch_application_upload" component={BatchApplicationUpload} />
          <ProtectedRoute exact id="pending_approval" path="/pending_approval" component={PendingApproval} />
          <ProtectedRoute exact id="awaiting_completion" path="/awaiting_completion" component={AwaitingCompletion} />
          <ProtectedRoute exact id="live_instruments" path="/live_instruments" component={LiveInstruments} />
          <ProtectedRoute exact id="deleted_instruments" path="/deleted_instruments" component={DeletedInstruments} />
          <ProtectedRoute exact id="instrument_history" path="/instrument_history" component={InstrumentHistory} />
          <ProtectedRoute exact id="instrument_expense_manager" path="/instrument_expense_manager" component={InstrumentExpenseManager} />
          <ProtectedRoute exact id="delete_instrument" path="/delete_instrument" component={DeleteInstrumentComponent} />
          <ProtectedRoute exact id="product_fix" path="/product_fix" component={ProductFix} />
          <ProtectedRoute exact id="instrument_summary" path="/instrument_summary" component={InstrumentSummary} />
          <Route key="daily_list_download" path="/daily_list_download" component={DailyListDownload} />
          <Route key="document_repository" path="/document_repository" component={InstrumentDocumentDownload} />
          <Route key="product_download" path="/product_download" component={ProductDownload} />
          <ProtectedRoute exact id="market_close_calendar" path="/market_close_calendar" component={MarketCloseCalendar} />
          <Route key="service_access_key" path="/service_access_key" component={ServiceAccessKey} />
          <Route key="symbol_directory" path="/symbol_directory" component={SymbolDirectory} />
          <ProtectedRoute key="portfolio_setup" path="/portfolio_setup" component={PortfolioManager} />
          <ProtectedRoute exact id="billing_contacts_report" path="/billing_contacts_report" component={BillingContactsReport} />
          <ProtectedRoute key="reconciliation_report" path="/reconciliation_report" component={ReconciliationReport} />
          <ProtectedRoute key="batch_expense_upload" path="/batch_expense_upload" component={BatchExpenseUpload} />
          <ProtectedRoute key="content_management_system" path="/content_management_system" component={ContentManagementSystem} />
        </React.Suspense>
        <Route key="*" component={NoMatch} />
      </Switch>
    </StyledMain>
  )
}

export default Routes
